<template>
  <div id="PowiazanieModulu">

    <div id="content">

      <h3>Lista powiązań modułów z obudową</h3>

      <div class="list">
        <md-list :md-expand-single="expandSingle">
          <md-list-item md-expand :md-expanded.sync="expandNews">
            <span class="md-list-item-text">+ dodaj nowe powiązanie</span>

            <md-list slot="md-expand">
              <PowiazanieModulyDodanie @someEvent="callback"/>
            </md-list>
          </md-list-item>
        </md-list>
      </div>

      <vue-good-table
      :columns="columns"
      :rows="powiazania"
      :sort-options="{
        enabled: true,
        initialSortBy: localSort
      }"
      :search-options="{
        enabled: true,
        placeholder: 'Szukaj...'
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        position: 'top',
        perPageDropdown: [40, 80, 100],
        dropdownAllowAll: false,
        nextLabel: '',
        prevLabel: '',
        rowsPerPageLabel: 'Ilość wierszy',
        ofLabel: 'z',
        pageLabel: 'strona',
        allLabel: 'Wszystko'
      }"
      styleClass="vgt-table striped"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'btn'" style="float: left;margin: 0px;">
            <button class="btnAction" style="color: #118af4; background:none" @click="editItem(props.row), editPanel = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
            </button>
            <button class="btnAction" style="color: red; background:none" @click="deleteItem(props.row)">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
              </svg>
            </button>
            <button class="btnAction" style="color: green; background:none;margin-left:10px" @click="correctImage(props.row)">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-tools" viewBox="0 0 16 16">
                <path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814L1 0Zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708ZM3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026L3 11Z"/>
              </svg> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
                <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>
              </svg>
            </button>
            <!--  @mouseover="overView(true,props.row)" @mouseleave="overView(false)"> -->
            <!-- <div style="width: 20px;height: 20px;float: right;text-align: right;margin-left: 28px;cursor: zoom-in;color: dimgray;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
                <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>
              </svg>
            </div> -->
          </span>
        </template>

      </vue-good-table>

      <md-dialog :md-active.sync="editPanel">
        <md-dialog-title>Edytuj powiązanie</md-dialog-title>
        <md-dialog-content>
          <table id="tableDialog">
            <tr>
              <td>
                obudowa
              </td>
              <td>
                <select v-model="fieldsData.id_obudowa" name="producent" id="producent" placeholder="obudowa"
                class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <!-- <option value="null">wybierz obudowę</option> -->
                  <option v-for="obudowa in obudowy" :key="obudowa.id_obudowa" :value="obudowa.id_obudowa">{{obudowa.symbol}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>
                modul
              </td>
              <td>
                <select v-model="fieldsData.id_modul" name="producent" id="producent" placeholder="centrala"
                class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <!-- <option value="null">wybierz centralę</option> -->
                  <option v-for="modul in moduly" :key="modul.idmodul" :value="modul.idmodul">{{modul.producent}} : {{modul.model}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>wspX</td>
              <td>
                <div class="md-layout-item">
                  <input v-model="fieldsData.wspX" class="form-control form-control-sm" type="text" style="margin: 0px;;display: inline-flex;">
                </div>
              </td>
            </tr>
            <tr>
              <td>wspY</td>
              <td>
                <div class="md-layout-item">
                  <input v-model="fieldsData.wspY" class="form-control form-control-sm" type="text" style="margin: 0px;;display: inline-flex;">
                </div>
              </td>
            </tr>
            <tr>
              <td>ułożenie</td>
              <td>
                <input type="checkbox" value=1 v-model="fieldsData.o0">&nbsp; 0&#176; &nbsp;
                <input type="checkbox" value=1 v-model="fieldsData.o90">&nbsp; 90&#176; &nbsp;
                <input type="checkbox" value=1 v-model="fieldsData.o180">&nbsp; 180&#176; &nbsp;
                <input type="checkbox" value=1 v-model="fieldsData.o270">&nbsp; 270&#176; &nbsp;
                <!-- <select v-model="fieldsData.o0" name="o1" id="o1" placeholder=""
                  class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=null>-</option>
                  <option value=1>TAK</option>
                </select> -->
              </td>
            </tr>
            <!-- <tr>
              <td>obrót 90&#176;</td>
              <td>
                <select v-model="fieldsData.o90" name="o2" id="o2" placeholder=""
                  class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=null>-</option>
                  <option value=1>TAK</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>obrót 180&#176;</td>
              <td>
                <select v-model="fieldsData.o180" name="o3" id="o3" placeholder=""
                  class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=null>-</option>
                  <option value=1>TAK</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>obrót 270&#176;</td>
              <td>
                <select v-model="fieldsData.o270" name="o4" id="o4" placeholder=""
                  class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=null>-</option>
                  <option value=1>TAK</option>
                </select>
              </td>
            </tr> -->
            <tr>
              <td>ścianka</td>
              <td>
                <div class="md-layout-item">
                    <select v-model="fieldsData.scianka" name="scianka" id="scianka" placeholder=""
                    class="form-select form-select-sm" aria-label=".form-select-sm example">
                      <option v-for="v in groupViews" :key="v">{{v}}</option>
                    </select>
                </div>
              </td>
            </tr>
            <tr>
              <td>aktywna</td>
              <td>
                <select v-model="fieldsData.widocznosc" name="widocznosc" id="widocznosc"
                    class="form-select form-select-sm" aria-label=".form-select-sm example">
                  <option value=1>TAK</option>
                  <option value=0>NIE</option>
                </select>
              </td>
            </tr>
          </table>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button class="md-primary" @click="editPanel = false">pomiń</md-button>
          <md-button class="md-primary" @click="saveItem(fieldsData)">zapisz</md-button>
        </md-dialog-actions>

      </md-dialog>

      <md-dialog :md-active.sync="correctCanvas" style="overflow: hidden;">
        <md-dialog-title style="margin: 4px;  margin-left: 4px;padding: 0px;font-size: 14px;margin-left: 10px;"><b>{{fieldsData.obudowa}}</b> || <b style="color:#08b008">{{fieldsData.modul}}</b></md-dialog-title>
        <md-dialog-actions style="margin: 0px;padding: 0px;height: 20px;min-height: 15px;position: absolute;right: 2px;top: 6px;">
          <md-button class="md-primary" @click="correctCanvas = false">pomiń</md-button>
          <!-- <md-button class="md-primary" @click="saveItem(fieldsData)">zapisz</md-button> -->
        </md-dialog-actions>

        <md-dialog-content>
          <!-- <CanvasCorrect :powiazanie="fieldsData" :typ="'modul'"/> -->
          <CanvasCorrectTest :powiazanie="fieldsData" :typ="'modul'"/>
        </md-dialog-content>

      </md-dialog>

    </div>

    <md-dialog-alert
      :md-active.sync="msgBox"
      :md-content="msgInfo"
      md-confirm-text="OK" />

  </div>
</template>

<script>
import { app } from '../mixins/functions'
import { mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

import PowiazanieModulyDodanie from './PowiazanieModulyDodanie'
// import CanvasCorrect from './CanvasCorrect'
import CanvasCorrectTest from './CanvasCorrectTest'

export default {
  name: 'PowiazanieModulu',
  mixins: [app],
  data () {
    return {
      msgBox: false,
      msgInfo: '',
      fieldsData: {
        'obudowa': null,
        'id_obudowa': null,
        'modul': null,
        'id_modul': null,
        'wspX': 0,
        'wspY': 0,
        'o0': null,
        'o90': null,
        'o180': null,
        'o270': null,
        'scianka': 'C',
        'widocznosc': 1
      },
      columns: [
        { label: 'Obudowa',field: 'obudowa' },
        { label: 'Moduł', field: 'modul' },
        { label: 'wspX',field: 'wspX' },
        { label: 'wspY',field: 'wspY' },
        { label: 'o0',field: 'o0', formatFn: this.formatFn, tdClass: this.tdClassFunc0 },
        { label: 'o90',field: 'o90', formatFn: this.formatFn, tdClass: this.tdClassFunc90 },
        { label: 'o180',field: 'o180', formatFn: this.formatFn, tdClass: this.tdClassFunc180 },
        { label: 'o270',field: 'o270', formatFn: this.formatFn, tdClass: this.tdClassFunc270 },
        { label: 'Ścianka',field: 'scianka' },
        { label: 'Aktywny',field: 'widocznosc' },
        { label: '', field: 'btn', width: '110px' }
      ],
      localSort: [
        {field: 'obudowa', type: 'asc'},{field: 'modul', type: 'asc'}
      ],
      editPanel: false,
      expandNews: false,
      expandSingle: false,
      correctCanvas: false
    }
  },
  components: {
    VueGoodTable, PowiazanieModulyDodanie, CanvasCorrectTest // CanvasCorrect
  },
  computed: {
    ...mapGetters('products', ['powiazania']),
    ...mapGetters('products', ['moduly', 'obudowy'])
  },
  methods: {
    load_powiazania () {
      this.$store.dispatch('products/load_powiazania_moduly')
    },
    load_obudowy () {
      this.$store.dispatch('products/load_obudowy')
    },
    load_moduly () {
      this.$store.dispatch('products/load_moduly')
      // this.lista.central = JSON.parse(JSON.stringify(this.centrale))
    },
    deleteItem (item) {
      let text = "Czy na pewno usunąć powiązanie?";
      if (confirm(text) == true) {
        this.$store.dispatch('products/send_connection_moduly', {'action': 'delete', 'fields': item}).then(info => {
          this.msgBox = true
          this.msgInfo = info.msg
        })
      } else {

      }
    },
    correctImage (item) {
      this.fieldsData = Object.assign({}, item);
      this.correctCanvas = true
    },
    editItem (item) {
      this.fieldsData = Object.assign({}, item);
      // this.editPanel = false
      // console.log(item)
      // let text = "Czy na pewno chcesz edytować powiązanie?";
      // if (confirm(text) == true) {
        // this.editPanel = true
        // this.$store.dispatch('products/send_connection', {'action': 'edit', 'fields': item})
      // } else {
      // }
    },
    saveItem (item) {
      this.editPanel = false

      if (this.fieldsData['wspX'] !== '' && this.fieldsData['wspX'] !== 0) {
        this.fieldsData['wspX'] = this.fieldsData['wspX'].replace(',', '.')
      }
      if (this.fieldsData['wspY'] !== '' && this.fieldsData['wspY'] !== 0) {
        this.fieldsData['wspY'] = this.fieldsData['wspY'].replace(',', '.')
      }

      this.$store.dispatch('products/send_connection_moduly', {'action': 'edit', 'fields': this.fieldsData}).then(info => {
        this.msgBox = true
        this.msgInfo = info.msg
      })
    },
    callback (e) {
      if (e) {
        this.expandSingle = false
        this.expandNews = false
        this.msgBox = true
        this.msgInfo = 'Dodano nowe powiązanie obudowa - moduł'
      }
    },
    overView(check, item) {
      if (check === true) {
        this.fieldsData = Object.assign({}, item);
        this.correctCanvas = true
      }
    }
  },
  created() {
    this.load_powiazania()
    this.load_obudowy()
    this.load_moduly()
  }
}
</script>

<style scoped>
.md-dialog-content {
  overflow: hidden;
}

table#tableDialog tr{
height: 40px;
}
  .btnAction {
    border: none;
    padding: 0px;
  }
#content {
  max-width: 1200px;
  margin: 0px auto;
}
#content h3 {
  background: beige;
  padding: 10px;
  font-size: 20px;
  text-transform: uppercase;
}
#content .table {
  margin-top:40px
}
#content .table tr.head {
  background: #3f7bc8;
}
#content .table tr th {
font-size: 14px;
font-weight: normal;
color: #fff;
padding: 4px;
border-left: 2px solid white;
}
.inputWsp {
  width: 80px;
  text-align: center;
  margin: 0px auto;
}
.md-ripple {
  min-height: 30px;
}
#tabPanel tr td input {
  width: 65px;
  padding: 4px;
  text-align: center;
}
.form-select, .form-control {
  padding: 4px 6px;
}
.inputSmall {
  width:65px;
}
.longSmall {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PowiazanieModuly.vue